import http from "@/services/http";
import { useAuth } from "@/services/auth.js";

export const clients = () => {
  const auth = useAuth();

  async function list(params = {}) {
    try {
      const { data } = await http.get('/admin/clients', { ...auth.getBearer(), params });
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  async function show(id) {
    try {
      const { data } = await http.get(`/admin/clients/${id}`, auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  async function create(payload) {
    try {
      const { data } = await http.post('/admin/clients', payload, auth.getBearer());
      return data.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function update(id, payload) {
    try {
      const { data } = await http.put(`/admin/clients/${id}`, payload, auth.getBearer());
      return data.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function resetPassword(id, payload) {
    try {
      await http.post(`/admin/clients/${id}/reset-password`, payload, auth.getBearer());
      return true;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function updatePlan(id, planId, planExpiresAt = null) {
    try {
      const { data } = await http.put(`/admin/clients/${id}/plan`, { plan_id: planId, plan_expires_at: planExpiresAt }, auth.getBearer());
      return data.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function stats(id) {
    try {
      const { data } = await http.get(`/admin/clients/${id}/stats`, auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  return { list, show, create, update, resetPassword, updatePlan, stats }
}
